var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49798 3.843C8.67644 3.843 8.85165 3.89076 9.00542 3.98132C9.15919 4.07188 9.28593 4.20194 9.37248 4.358L10.5955 6.561C10.6743 6.70311 10.7174 6.86229 10.7209 7.02478C10.7243 7.18726 10.6882 7.34815 10.6155 7.4935L9.43748 9.8505C9.43748 9.8505 9.77898 11.606 11.208 13.0355C12.6375 14.4645 14.387 14.8005 14.387 14.8005L16.7435 13.622C16.8889 13.5492 17.0499 13.513 17.2125 13.5165C17.375 13.52 17.5343 13.5631 17.6765 13.642L19.8865 14.871C20.0422 14.9577 20.1719 15.0845 20.2622 15.2381C20.3525 15.3918 20.4 15.5668 20.4 15.745V18.2815C20.4 19.5735 19.2 20.5065 17.976 20.0935C15.462 19.245 11.5595 17.63 9.08598 15.1565C6.61298 12.683 4.99748 8.781 4.14948 6.2665C3.73648 5.043 4.66948 3.843 5.96148 3.843H8.49798Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneOutline);
export default __webpack_public_path__ + "static/media/ic-phone-outline.b406040489cc9bf90a77518550772ed7.svg";
export { ForwardRef as ReactComponent };